import React, { useEffect, useState } from "react";

import {
  fetchProcessNotePage,
  // fetchDeleteProcessNote,
  fetchUpdateProcessNote,
  getIsLoadingProcessNotePage,
  getPaginationProcessNotePage,
} from "store/slices/processNote";
import EndOfShiftNoteModal from "./EndOfShiftNoteModal";
import { makeStyles } from "@material-ui/core/styles";
import { Person } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import { Box, Grid, TextareaAutosize, Typography } from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import Dropdown from "react-bootstrap/Dropdown";
import ComponentLoading from "../../../../components/Common/ComponentLoading";
import Pagination from "@material-ui/lab/Pagination";
// import { JOB_STATUS } from "config/AppConfig";
import AppButton from "components/CustomButtons/AppButton";
import { Formik } from "formik";
import * as Yup from "yup";
import AppConfig from "config/AppConfig";
import ReadMore from "components/Input/ReadMoreText";
import IconButton from "@material-ui/core/IconButton";
import CachedIcon from "@material-ui/icons/Cached";
import AppUtil from "utilities/AppUtil";
import AppColor from "utilities/AppColor";

const { PATTERNS } = AppConfig;

const useStyles = makeStyles(() => ({
  noteContent: {
    boxSizing: "border-box",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#FFFFFF",
  },
  processNote: {
    width: "100%",
    height: "auto",
    border: "1px #000000 10%",
    padding: "20px",
  },
  icons: {
    cursor: "pointer",
    height: "49px",
    width: "49px",
    background: "#FFFFFF",
    border: "0.5px solid #000000",
    borderRadius: "24px",
  },
  listNote: {
    width: "100%",
    height: "auto",
    border: "1px #000000 10%",
    padding: "20px",
  },
  horizontalBar: {
    marginTop: "1rem",
    marginBottom: "1rem",
    border: "1px solid #cacaca",
    textAlign: "center",
    width: "95%",
    borderTop: "0",
  },
  customUserName: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
    color: "#C78D3C",
  },
  customDayNote: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
    color: "#000000",
  },
  textField: {
    width: "100%",
    "& .MuiInputBase-input": {
      height: "200px",
      verticalAlign: "top",
    },
  },
  moreLess: {
    height: "auto",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  readMore: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    border: "0px",
    fontSize: "14px",
  },
  button: {
    border: "0px",
    backgroundColor: "rgba(196, 196, 196, 0.5)",
    borderRadius: "5px",
    marginLeft: "5px",
    "& :hover": {
      color: "#000000",
    },
  },
  customButton: {
    width: "35px",
    height: "30px",
    border: "0px",
    borderRadius: "35px",
    backgroundColor: "rgba(196, 196, 196, 0.5)",
    color: "#000000",
    textAlign: "center",
  },
  dropDown: {
    "& .dropdown-toggle": {
      color: "#000000",
      backgroundColor: "rgba(196, 196, 196, 0.5)",
      border: "0px",
      borderRadius: "35px",
    },
    "& .dropdown-toggle:hover": {
      color: "#000000",
      backgroundColor: "rgba(196, 196, 196, 0.5)",
      border: "0px",
      borderRadius: "35px",
    },
    "& .dropdown-toggle:focus": {
      color: "#000000",
      backgroundColor: "rgba(196, 196, 196, 0.5)",
      border: "0px",
      borderRadius: "35px",
    },
    "& .dropdown-toggle::after": {
      display: "none",
    },
  },
  dropDownToggle: {
    "& button": {
      color: "red",
    },
  },
  pagination: {
    "& ul": {
      justifyContent: "flex-end",
    },
  },
}));

const ProcessNoteContent = (props) => {
  const { jobId, processNote, workerId, resetWorker, isDisable } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoadingProcessNotePage);
  const pagination = useSelector(getPaginationProcessNotePage);
  const [isOpenEdit, setOpenEdit] = useState(false);
  const [isReadMore, setReadMore] = useState(false);
  const [idNote, setIdNote] = useState(0);
  const [message, setMessage] = useState("");
  const [showNoteModal, setShowNoteModal] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (jobId) {
      const request = {
        jobId: jobId,
        pageNumber: 1,
        pageSize: pagination.pageSize,
        workerId: workerId
      };
      dispatch(fetchProcessNotePage(request));
    }
  }, []);

  const handleChangeIncident = (data) => {
    const request = {
      id: data.id,
      note: data.note,
      isIncident: !data.isIncident,
      queries: {
        pageNumber: pagination.page,
        pageSize: pagination.pageSize,
        jobId: jobId,
        workerId: workerId
      },
    };
    dispatch(fetchUpdateProcessNote(request));
  };

  // const handleOpenEditNote = (data) => {
  //   setOpenEdit(true);
  //   setIdNote(data.id);
  //   setMessage(data.note);
  //   processNote.map((item) => {
  //     if (item.id === data.id) {
  //       setOpenEdit(true);
  //     }
  //   });
  // };


  // const handleDeleteNote = (data) => {
  //   const request = {
  //     queries: {
  //       pageNumber: pagination.page,
  //       pageSize: pagination.pageSize,
  //       jobId: jobId,
  //     },
  //     id: data.id,
  //   };
  //   if (pagination.page > 1 && pagination.numberOfElements === 1) {
  //     request.queries.pageNumber = pagination.page - 1;
  //   }
  //   dispatch(fetchDeleteProcessNote(request));
  // };
  const handleChangeNote = (event, item) => {
    event.preventDefault();
    const request = {
      note: message,
      id: item.id,
      isIncident: item.isIncident,
      queries: {
        pageNumber: pagination.page,
        pageSize: pagination.pageSize,
        jobId: jobId,
        workerId: workerId
      },
    };
    dispatch(fetchUpdateProcessNote(request));
    setOpenEdit(false);
  };

  const handlePageChange = (event, page) => {
    event.preventDefault();
    const request = {
      jobId: jobId,
      pageNumber: page,
      pageSize: pagination.pageSize,
      workerId: workerId
    };
    dispatch(fetchProcessNotePage(request));
    const mainPanel = document.getElementById("main-panel");
    mainPanel.scrollTop = 1070;
    if (resetWorker) {
      AppUtil.scrollToTopById("main-panel");
    }
  };

  const handleReloadPage = (event) => {
    event.preventDefault();
    const request = {
      jobId: jobId,
      pageNumber: pagination.page,
      pageSize: pagination.pageSize,
      workerId: workerId
    };
    dispatch(fetchProcessNotePage(request));
  };

  const isCharacterDownTheLine = (text) => {
    return text.indexOf("\n") != -1 ? true : false;
  };
  const isTooManyCharacterDownTheLine = (text) => {
    const isCheck = text.split("\n");
    if (isCheck.length > 3) {
      return true;
    } else {
      return false;
    }
  }

  const formatMessageReadMore = (item) => {
    const newMessage = !isTooManyCharacterDownTheLine(item.note) ?
      (item.note.split("\n")
        .map((str, index) => <div key={str + item.id + index}>{str + " "}</div>))
      : item.note
        .split("\n")
        .map((str, index) =>
          index === 0 ? (
            <div key={str + 1 + index + item.id + 2}>{str}</div>
          ) : index === 1 ? (
            <div key={str + 1 + index + item.id + 2}>{`${str}...`}
              <span><a href="#" style={{ width: "90px", fontWeight: 600 }} onClick={(event) => { event.preventDefault(); setReadMore(true); setIdNote(item.id) }}>{t("button.readMore")}</a></span>
            </div>
          ) : (
            ""
          )
        );
    return <div key={`${item.id}-read-more`} id={`${item.id}-read-more`}>{newMessage}</div>;
  };

  const formatMessageShowLess = (item) => {
    const newMessage = item.note
      .split("\n")
      .map((str, index) =>
        index < item.note.split("\n").length - 1 ? (
          <div key={str + 1 + index + item.id}>{str}</div>
        ) : index === item.note.split("\n").length - 1 ? (
          <div key={str + 1 + index + item.id}>{str}
            <span><a href="#" style={{ width: "90px", fontWeight: 600 }} onClick={(event) => { event.preventDefault(); setReadMore(false); setIdNote(item.id) }}>{t("button.showLess")}</a></span>
          </div>
        ) : (
          ""
        )
      );
    return <div key={`${item.id}-show-less`} id={`${item.id}-show-less`}>{newMessage}</div>;
  };

  const renderMoreAction = (item) => (
    <Dropdown className={classes.dropDown}>
      <Dropdown.Toggle>
        <MoreHorizIcon></MoreHorizIcon>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {/* {!item.workerId && (
          <>
            <Dropdown.Item
              onClick={() => {
                handleOpenEditNote(item);
              }}
            >
              {t("label.edit")}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                handleDeleteNote(item);
              }}
            >
              {t("button.delete")}
            </Dropdown.Item>
          </>
        )} */}
        {isDisable ? (
          <Dropdown.Item disabled>{t("label.reportIncident")}</Dropdown.Item>
        ) : (
          <Dropdown.Item
            onClick={() => {
              handleChangeIncident(item);
            }}
          >
            {item.isIncident
              ? t("label.cancelIncident")
              : t("label.reportIncident")}
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );

  const renderTextNote = (item) => (
    <React.Fragment
      key={`${item.id}-${item.clientId ? item.clientId : item.workerId ? item.workerId : " "
        }`}
    >
      {item.note.length < 67 ? (
        // <div onClick={() => {setIdNote(item.id)}}>{formatMessageNoteLessThan67(item)}</div>
        isCharacterDownTheLine(item.note) ? (
          isReadMore && idNote === item.id ? (
            formatMessageShowLess(item)
          ) : (
            formatMessageReadMore(item)
          )
        ) : (
          item.note
        )
      ) : (
        <ReadMore lines={2}>{item.note}</ReadMore>
      )}
    </React.Fragment>
  );

  return (
    <Box 
      style={{ marginTop: "40px" }} 
      options={{
        suppressScrollX: true,
        suppressScrollY: false,
      }} 
      id="progress-note">
      <Typography
        style={{
          color: "#3D2C3E 50%",
          fontStyle: "normal",
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "19px",
          marginBottom: "10px",
        }}
      >
        {t("title.note")}
      </Typography>
      <Box className={classes.noteContent}>
        {/* End-of-shift note entry button */}
        <Grid container className={classes.processNote} alignItems="center" justifyContent="space-between">
          <Grid item>
            <Box style={{ fontSize: 13, color: "#6B7280" }}>
              {t("title.note")}
            </Box>
          </Grid>
          <Grid item>
            <AppButton
              label="+ Write end-of-shift note"
              onClick={() => setShowNoteModal(true)}
              disabled={isDisable}
              buttonColor={AppColor.mainColor}
              rounder
              style={{ fontSize: 12, textTransform: "none" }}
            />
          </Grid>
        </Grid>

        {/* Structured note modal */}
        <EndOfShiftNoteModal
          open={showNoteModal}
          onClose={() => setShowNoteModal(false)}
          jobId={jobId}
          onSuccess={() => {
            setShowNoteModal(false);
            resetWorker && resetWorker();
            dispatch(fetchProcessNotePage({
              jobId,
              pageNumber: 1,
              pageSize: pagination.pageSize,
              workerId,
            }));
          }}
        />
        <Box style={{ width: "99%", textAlign: "end" }}>
          <IconButton
            color="primary"
            aria-label="reload page"
            onClick={handleReloadPage}
            disabled={isLoading || isDisable}
          >
            <CachedIcon />
          </IconButton>
        </Box>
        {isLoading && <ComponentLoading />}
        {!isLoading && processNote && processNote.length > 0 && (
          <Box>
            {processNote.map((item, index) => {
              return (
                <Box
                  key={`note-${index}-${item.id}-${item.clientId || item.workerId}`}
                  index={index}
                >
                  <Grid
                    container
                    className={classes.listNote}
                    name={`note-${index}-${item.id}`}
                    style={{
                      backgroundColor: `${item.isIncident ? "#E9655D" : ""}`,
                    }}
                  >
                    <Grid item sx={12} sm={1} style={{ textAlign: "center" }}>
                      {!item.avatarAws3Link ? (
                        <Person className={classes.icons} />
                      ) : (
                        <img src={item.avatarAws3Link} className={classes.icons}/>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={11}>
                      <Grid container>
                        <Grid item xs={12}>
                          <span
                            className={classes.customUserName}
                            style={{ color: item.isIncident ? "#FFFFFF" : "" }}
                          >
                            {item.firstName + " " + item.lastName + " "}
                          </span>
                          <Brightness1Icon
                            style={{
                              fontSize: "5px",
                              color: item.isIncident ? "#FFFFFF" : "#000000",
                            }}
                          />
                          <span
                            className={classes.customDayNote}
                            style={{ color: item.isIncident ? "#FFFFFF" : "" }}
                          >
                            {" " +
                              moment(new Date(item.createdDate)).format(
                                "DD/MM/YYYY HH:mm"
                              )}
                          </span>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container>
                            <Grid item xs={6} style={{ marginTop: "5px" }}>
                              {isOpenEdit && item.id === idNote ? (
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{
                                    editNote: "",
                                  }}
                                  validationSchema={Yup.object().shape({
                                    note: Yup.string()
                                      .trim()
                                      .matches(
                                        PATTERNS.BLANK_SPACES,
                                        "validation.blankSpaces"
                                      )
                                      .max(1000, "validation.max_length_1000"),
                                  })}
                                >
                                  {(formikProps) => {
                                    const { setFieldValue } = formikProps;
                                    return (
                                      <Box>
                                        <TextareaAutosize
                                          name="editNote"
                                          style={{
                                            width: "100%",
                                            height: "100px",
                                            color: item.isIncident
                                              ? "#000000"
                                              : "",
                                            padding: "10px",
                                          }}
                                          onChange={(event) => {
                                            setFieldValue(
                                              "editNote",
                                              event.target.value
                                            );
                                            setMessage(event.target.value);
                                          }}
                                          value={message}
                                        />
                                        <AppButton
                                          label={`${t("button.save_changes")}`}
                                          type="button"
                                          onClick={(event) => {
                                            handleChangeNote(event, item);
                                          }}
                                        />
                                        <AppButton
                                          className="ml-1"
                                          label={`${t("button.cancel")}`}
                                          type="button"
                                          mode="outlined"
                                          buttonColor={
                                            item.isIncident ? "#FFFFFF" : ""
                                          }
                                          onClick={() => {
                                            setOpenEdit(false);
                                          }}
                                        />
                                      </Box>
                                    );
                                  }}
                                </Formik>
                              ) : (
                                renderTextNote(item)
                              )}
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: "end" }}>
                              {renderMoreAction(item)}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <hr className={classes.horizontalBar}></hr>
                </Box>
              );
            })}
            <Pagination
              className={classes.pagination}
              count={pagination.totalPages}
              page={pagination.page}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        )}
        {!isLoading && processNote.length === 0 && (
          <Typography style={{ textAlign: "center", height: "50px" }}>
            {t("label.no_data")}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
ProcessNoteContent.propTypes = {
  jobId: PropTypes.any,
  jobStatus: PropTypes.string,
  processNote: PropTypes.array,
  workerId: PropTypes.any,
  resetWorker: PropTypes.func,
  isDisable: PropTypes.bool,
};

export default ProcessNoteContent;
